module.exports = __webpack_public_path__ + "static/media/goals.cc1b66d9.svg";